module.exports = "/assets/data/1bcf75583aaf1a49379aad72baa1c41f-SG2.data.json";